import { ITimeDomain } from "@types"
import { protectedApi } from "store/Api"

const settingsTimeDomain: any = protectedApi.injectEndpoints({

    endpoints: (builder) => ({
        settingsTimeDomain: builder.query<ITimeDomain[], void>({
            query: () => {
                return {
                    method: "GET",
                    url: `settings/time_domains`,
                }
            },
        }),
    }),
})

export const { useSettingsTimeDomainQuery } = settingsTimeDomain
